export enum AccountTypeEnum {
  Custom,
  Esia,
  Stranger,
}
